import React, { useState, useEffect } from 'react';
import { motion, useInView } from 'motion/react';
import { Users, Recycle, Droplet } from 'lucide-react';

const STATS = [
  { icon: Users, value: 30, suffix: '', label: 'Local Farmers Empowered' },
  { icon: Recycle, value: 100, suffix: '%', label: 'Zero-Waste Facility' },
  { icon: Droplet, value: 0, suffix: '', label: 'Chemical Additives' },
];

const Counter = ({ value, suffix }: { value: number, suffix: string }) => {
  const [count, setCount] = useState(0);
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      let start = 0;
      const end = value;
      if (end === 0) return;
      const duration = 2000;
      const incrementTime = (duration / end) * 2;
      
      const timer = setInterval(() => {
        start += 1;
        setCount(start);
        if (start >= end) {
            setCount(end);
            clearInterval(timer);
        }
      }, incrementTime);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);

  return <span ref={ref}>{value === 0 ? 0 : count}{suffix}</span>;
};

export const StatsSection: React.FC = () => {
  return (
    <section className="py-16 bg-avo-cream border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {STATS.map((stat, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="flex flex-col items-center"
            >
              <div className="w-12 h-12 bg-avo-gold/20 text-avo-forest rounded-full flex items-center justify-center mb-4">
                <stat.icon size={24} />
              </div>
              <h3 className="text-4xl font-heading font-bold text-gray-900 mb-2">
                <Counter value={stat.value} suffix={stat.suffix} />
              </h3>
              <p className="text-gray-600 font-medium">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
